import type { Choice, DateNightStep } from "../types/dateNight";

export const starters: Choice[] = [
  { id: "crispy-salmon-bites", title: "Crispy salmon bites", description: "Zalm · avocado · komkommer · spicy honey-soja", visualVariant: "coral" },
  { id: "garlic-lime-prawns", title: "Sticky garlic-lime gamba's", description: "Gamba's · knoflook · limoen · chili", visualVariant: "citrus" },
  { id: "chicken-taco-cups", title: "Mini chicken taco cups", description: "Kip · avocado · salsa · limoen", visualVariant: "terracotta" },
  { id: "bruschetta-pomodoro", title: "Bruschetta al pomodoro", description: "Getoast brood · tomaat · basilicum · knoflook", visualVariant: "tomato" },
  { id: "miso-aubergine", title: "Sticky miso-aubergine", description: "Aubergine · miso · sesam · lente-ui", visualVariant: "aubergine" },
  { id: "beef-tataki", title: "Asian beef tataki", description: "Rosé rund · soja-limoen · sesam", visualVariant: "wine" },
];

export const mains: Choice[] = [
  { id: "honey-garlic-salmon", title: "Honey-garlic salmon", description: "Zalm · honey-garlic · groene groenten · sesam", visualVariant: "coral" },
  { id: "creamy-cajun-chicken-breast", title: "Creamy Cajun kipfilet", description: "Kipfilet · Cajun · paprika · romige saus", visualVariant: "terracotta" },
  { id: "mexican-chicken-breast", title: "Mexican kipfilet", description: "Kipfilet · avocado · salsa · limoen", visualVariant: "citrus" },
  { id: "korean-style-steak", title: "Korean-style steak", description: "Rosé steak · soja · knoflook · sesam", visualVariant: "wine" },
  { id: "teriyaki-chicken-breast", title: "Teriyaki kipfilet", description: "Kipfilet · teriyaki · groene groenten · sesam", visualVariant: "tomato" },
  { id: "coconut-lime-prawn-curry", title: "Coconut-lime prawn curry", description: "Gamba's · kokos · limoen · groene groenten", visualVariant: "aubergine" },
];

export const activities: Choice[] = [
  { id: "movie", title: "Film kijken", icon: "🎬" },
  { id: "massage", title: "Massage", icon: "💆" },
  { id: "caresses", title: "Strelingen", icon: "✨" },
  { id: "cuddle", title: "Knuffelen", icon: "🤍" },
  { id: "kiss", title: "Zoenen", icon: "💋" },
  { id: "game", title: "Spelletje spelen", icon: "🎲" },
];

export const atmospheres: Choice[] = [
  { id: "candlelight", title: "Kaarslicht", description: "Kaarsen · zachte muziek · mooi gedekte tafel", icon: "🕯️", visualVariant: "candlelight" },
  { id: "restaurant-at-home", title: "Restaurant thuis", description: "Net iets chiquer · mooi opgemaakt · beetje aankleden", icon: "🥂", visualVariant: "champagne" },
  { id: "cozy", title: "Lekker knus", description: "Gedimd licht · comfortabel · relaxed samen", icon: "🛋️", visualVariant: "cozy" },
  { id: "surprise-me", title: "Verras me", description: "Jij hoeft echt niet alles te beslissen", icon: "♥", visualVariant: "surprise" },
];

export const steps: DateNightStep[] = ["welcome", "starter", "main", "dessert", "activities", "atmosphere", "summary", "confirmation"];

export const findChoice = (list: Choice[], id?: string) => list.find((choice) => choice.id === id);

export const displayName = (list: Choice[], id: string) => findChoice(list, id)?.title ?? id;
